import React from "react";
import Icon from "@ant-design/icons";
import type { CustomIconComponentProps } from "@ant-design/icons/lib/components/Icon";

const MoreIconSvg = () => (
  <svg width='4' height='14' viewBox='0 0 4 14' fill='none' xmlns='http://www.w3.org/2000/svg'>
    <path
      d='M3.5 12C3.5 12.8 2.8 13.5 2 13.5C1.2 13.5 0.5 12.8 0.5 12C0.5 11.2 1.2 10.5 2 10.5C2.8 10.5 3.5 11.2 3.5 12ZM3.5 7C3.5 7.8 2.8 8.5 2 8.5C1.2 8.5 0.5 7.8 0.5 7C0.5 6.2 1.2 5.5 2 5.5C2.8 5.5 3.5 6.2 3.5 7ZM3.5 2C3.5 2.8 2.8 3.5 2 3.5C1.2 3.5 0.5 2.8 0.5 2C0.5 1.2 1.2 0.5 2 0.5C2.8 0.5 3.5 1.2 3.5 2Z'
      fill='#A3ADB7'
    />
  </svg>
);

export const MoreIcon = (props: Partial<CustomIconComponentProps>) => (
  <Icon component={MoreIconSvg} {...props} />
);
